import { ReactComponent as CloseIcon } from "../../img/Close.svg";
import { ReactComponent as TenantsImg } from "../../img/Tenants.svg";
import { renderUnitDetailsModalContent } from "../../utils/utils";

import InviteMemberForm from "./InviteMemberForm";

export interface InviteTenantModalWizardProps {
  closeInviteTenantModal: () => void;
  homeName: string;
  propertyId: string;
}

const InviteMemberModal: React.FC<InviteTenantModalWizardProps> = ({
  closeInviteTenantModal,
  homeName,
  propertyId,
}) => {
  return (
    <div className="popup-background">
      <div className="tenants-show-container align-as-column">
        <div className="tenants-show-header">
          <div className="center-align-as-row">
            <TenantsImg title="Residents" />
            <div className="tenants-show-header-title unit-title">
              <b data-testid="invite-tenant-header">Add Home Member</b>
              <div className="tenants-show-header-title-name">: {homeName}</div>
            </div>
          </div>
          <CloseIcon
            onClick={() => {
              closeInviteTenantModal();
            }}
            className="changes-header-img"
            title="close"
          />
        </div>
        <div className="tenants-show-body">
          <div className="tenants-show-form-container">
            <div className="tenants-show-description-container">
              Please provide an e-mail of the Home Member you would like to add
              to <b>{homeName}</b>.
              {renderUnitDetailsModalContent({
                descriptionList: [
                  "The Home Member will be invited to access the home and its devices. The invite will remain active for 7 days.",
                ],
                title: "If you invite another Home Member:",
              })}
              {renderUnitDetailsModalContent({
                descriptionList: [
                  "The Home Member will gain access to the Brilliant Home and its devices.",
                ],
                title: "After the Home Member accepts the invite:",
              })}
            </div>
            <br />
            <div className="menu tenants-show-form-title">
              Invite Resident by Email
            </div>

            <InviteMemberForm
              closeModalFn={() => {
                closeInviteTenantModal();
              }}
              propertyId={propertyId}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default InviteMemberModal;
